export class WalletManagementModel {
  walletManagementId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  enterpriseId: number = 0;
  clientId: number = 0;
  dateWalletManagement: Date = new Date();
  contact: string | null = null;
  observation: string | null = null;
  active: boolean = true;
  createDate: Date = new Date();
  userNameCreate: string = "";
  updateDate: Date = new Date();
  userNameUpdate: string = "";
  quantityInvoices: number = 0;
  residueInvoices: number = 0;
}
